/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cashflow_Caveat_TitleInputs */

const vi_cashflow_caveat_title = /** @type {(inputs: Cashflow_Caveat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu ý giới hạn báo cáo`)
};

/**

* @param {Cashflow_Caveat_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cashflow_caveat_title = /** @type {((inputs?: Cashflow_Caveat_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cashflow_Caveat_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cashflow_caveat_title(inputs)
});